// extracted by mini-css-extract-plugin
export var calendarView = "_m0-0";